import { LegalPageLayout } from '../components/LegalPageLayout';

export function Component() {
  return <LegalPageLayout pageId="cookies" i18nPrefix="cookiePolicy" />;
}
